import Locale from '../locale'

export const BoltKeyList = [
  'A01',
  'A02',
  'B01',
  'B02',
  'B03',
  'B04',
  'B05',
  'B06',
  'B07',
  'B08',
  'B09',
  'B10',
  'B11',
  'B12',
  'B13',
  'B14',
  'B15',
  'B16',
]

export const ColorToStyle = {
  Green: {color:'#4CAF50'},
  Yellow: {color:'#FFC107'},
  Red:{color:'#F44336'},
  Blue:{color:'#03C'},
  Black:{color:'#795548'},
  Gray:{color:'#888'},
}


export const ColorMap = {
  '綠燈':'Green',
  '黃燈':'Yellow',
  '紅燈':'Red',
  '禁止':'Red',
  'AA': 'Red',
  'F304': 'Red',
  'F316': 'Green',
  'FCT': 'Red',
  'P38': 'Black',
  'EXP': 'Black',
  'TI': 'Green',
  'TIU': 'Green',
  'TITW': 'Green',
  'PC': 'Red',
  'PB': 'Red',
  'S_PRE': 'Gray',
  'S_NEXT': 'Gray',
  'SLING': 'Yellow',
  'CHECK': 'Blue',
}

export function getColorStyle(key) {
  return ColorToStyle[ColorMap[key]]
}


const locale = {
  'BoltTW': '台製316',
  'BoltTITW': '台製鈦Bolt',
  'BoltXX': '未知',
  'BoltEXP': '拉膨式Bolt',
  'Bolt_S_PRE': '和前一條路線共用',
  'Bolt_S_NEXT': '和後一條路線共用',
  'Bolt_CHECK': '未知，待更新',
  'BoltSling': '繩環',
}



export const BoltTypeList = [
  'AA',
  'F304',
  'F316',
  'FCT',
  'P38',
  'PC',
  'TW',
  'TI',
  'TIU',
  'TITW',
  'EXP',
]


export const BoltKeyMap = {
  'AA': 'AustriAlpin',
  'F304': 'Fixe 304',
  'F316': 'Fixe 316',
  'FCT': 'Ferno CT',
  'P38': 'Petzl Long Life',
  'PC': 'Petzl Collinox',
  'PB': 'Petzl Bat\'inox',
  'TW': locale.BoltTW,
  'TI': 'Titan Eterna',
  'TIU': 'Titan U',
  'TITW': locale.BoltTITW,
  'SLING': locale.BoltSling,
  'XX': locale.BoltXX,
  'EXP': locale.BoltEXP,
  'S_PRE': locale.Bolt_S_PRE,
  'S_NEXT': locale.Bolt_S_NEXT,
  'CHECK': locale.Bolt_CHECK,
}


export function boltColor(note) {
  if(!note)
    return
  let color = ColorMap[note]
  if(color)
    return color
  let notes = note.split('\n')

  let key = notes[0].split('_')
  if (key[1] && key[1].indexOf('D') > -1)
    return 'Red'

  if(key[0] === 'TW') {
    color = parseInt(key[1]) >= 10 ? 'Green' : 'Yellow'
  } else {
    color = ColorMap[key[0]] || color
  }

  let status = notes[1]
  if(status){
    status = status.toUpperCase()
    if(status.includes('OK')) {
      return (color==='Red') ? 'Yellow' : 'Green'
    }
    if(status.includes('WR')) {
      return 'Yellow'
    }
    if(status.includes('BRK')||status.includes('BAD')||status.includes('OUT')) {
      return 'Black'
    }
  }

  return color
}

function boltType(key){
  return BoltKeyMap[key] || BoltKeyMap[key.split('_')[0]]
}

function boltYear(key){
  let year = parseInt(key.split('_')[1])
  if(isNaN(year))
    return null
  else
    return 2000+year
}


const TestNoteKeyMap = {
  'OK':'合格',
  'BAD':'有問題',
  'BRK':'失敗斷裂',
  'OUT':'失敗拉出',
}

function processTestNote(note){
  if(note){
    Object.keys(TestNoteKeyMap).forEach(key=>{
      note=note.replace(key,Locale.R.bolt[key])
    })
  }
  return note
}

export function processBolt(note){
  if(!note)
    return {}
  let notes = note.split('\n')
  let key = notes[0]
  let testNote = notes[1]
  let testDate = notes[2]
  let color = boltColor(note)

  return {
    key,
    color,
    type:boltType(key),
    year:boltYear(key),
    style:ColorToStyle[color],
    testNote:processTestNote(testNote),
    testDate,
  }
}




/** WEBPACK FOOTER **
 ** ./src/app/utils/bolt.js
 **/